import debounce from 'lodash/debounce';

export const backgroundDirective = { // eslint-disable-line
  name: 'background',
  bind: (el, binding) => {
    // el.style.backgroundImage = `url('${getBackground(binding.value)}')`
    el.dataset.bg = `${getBackground(binding.value)}`;
    /* istanbul ignore next */
    window.addEventListener(
      'resize',
      debounce(() => {
        el.dataset.bg = `${getBackground(binding.value)}`;
      }, 200),
    );
  },
};

export const getBackground = (backgrounds, windowWidth) => {
  const currentWidth = windowWidth || window.innerWidth;
  const keys = Object.keys(backgrounds).reverse();
  const lastMatchingKey = keys.filter((key) => currentWidth >= key).shift();
  return backgrounds[lastMatchingKey];
};
